// This is the entry point for the app. Basic config happens here - Redux

import React from "react";
import { Provider } from "react-redux";
import Amplify from "aws-amplify";
// import aws_exports from "aws-exports.js";

import localPolyfill from "config/localPolyfill.js";

import initializeStore from "lib/initializeStore.js";

// Swap these to run offline
// import { SetupLoader } from "loaders";
import LoginController from "layout/LoginController";

// First LESS entry point
import "config/less/firstEntry.less";

localPolyfill();

Amplify.configure({
	Auth: {
		// REQUIRED - Amazon Cognito Identity Pool ID
		identityPoolId: "us-east-1:facfe972-c13a-4dea-96d8-372f1ac49197",
		// REQUIRED - Amazon Cognito Region
		region: "us-east-1",
		// OPTIONAL - Amazon Cognito User Pool ID
		userPoolId: "us-east-1_CKdun6kyr",
		// OPTIONAL - Amazon Cognito Web Client ID
		userPoolWebClientId: "4qn94eh0gheufak1vuqvtrhpap",
	},
	// Storage: {
	// 	AWSS3: {
	// 		bucket: "cbp-reports", // REQUIRED -  Amazon S3 bucket
	// 		region: "us-east-1", // OPTIONAL -  Amazon service region
	// 		identityPoolId: "us-east-1:facfe972-c13a-4dea-96d8-372f1ac49197",
	// 	},
	// },
});

// AWS debug mode (super verbose)
// if (process.env.NODE_ENV !== "production") {
// 	window.LOG_LEVEL = "DEBUG";
// }

// removed for production - causes sketchy yarn warnings.
// if (process.env.NODE_ENV !== "production") {
// 	const { whyDidYouUpdate } = require("why-did-you-update");
// 	whyDidYouUpdate(React);
// }

const store = initializeStore();

const App = () => {
	return (
		<Provider store={store}>
			<LoginController />
			{/* <SetupLoader /> */}
		</Provider>
	);
};

export default App;
